module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/peopleBlobs/gyasi.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/peopleBlobs/gyasi.png
// module id = 795
// module chunks = 5 6